<template>
  <div>
    <Ibox :back="true" :titulo="'Usuarios'">
      <b-col cols="12">
        <DataTable
          :loading="loading_tabla"
          :columns="columns"
          :rows="rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'asociado' && utils.tienePermiso()">
            <a v-if="props.row.asociado == 0" href="javascript:void(0)" v-on:click="putProgramaUsuario(props.row,'S')">Agregar a programa</a>
            <a v-else href="javascript:void(0)" style="color:red" v-on:click="putProgramaUsuario(props.row,'N')">Quitar de programa</a>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { programaService } from '@/services';
import { utils } from '@/helpers';

export default {
  name: 'Sucursales', 
  data(){
    return {
      utils,
      programa: utils.jd64(this.$route.params.programa),
      loading_tabla: true,
      columns:[
        {label: 'Nombre', field: 'nombre_usuario'},
        {label: '', field: 'asociado'},
      ],
      rows:[],
    }
  },
  mounted () {
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Configuración / Programa ' + this.programa.nombre_programa+ ' / Usuarios');
  },
  methods : {
    putProgramaUsuario(usuario, accion){
      programaService.putProgramaUsuario({
        id_usuario:usuario.id_usuario,
        id_programa:this.programa.id_programa,
        accion:accion,
        forzar:'N'
      }).then(data => {
        if(data.status == 'success'){
          //socket
          this.$socket.emit('prevn', 
            {
              id_usuario:usuario.id_usuario,
              dispatch:'usuario/sincronizar'
            }
          );
          
          this.cargarDatos();
        }else if(data.status == 'warning'){

          this.$confirm(data.msg).then(() => {
            programaService.putProgramaUsuario({
              id_usuario:usuario.id_usuario,
              id_programa:this.programa.id_programa,
              accion:accion,
              forzar:'S'
            }).then(data => {
              if(data.status == 'success'){
                //socket
                this.$socket.emit('prevn', 
                  {
                    id_usuario:usuario.id_usuario,
                    dispatch:'usuario/sincronizar'
                  }
                );
                
                this.cargarDatos();
              }else if(data.status == 'danger'){
                utils.alerta(data);
              }
            });
          });
        }else if(data.status == 'danger'){
          utils.alerta(data);
        }
      });
    },
    cargarDatos(){
      programaService.getProgramaUsuariosAsociados({
        id_programa:this.programa.id_programa
      }).then(data => {
        this.rows = data.data;

        this.loading_tabla = false;
      });
    },
  }
}
</script>

<style scoped>

</style>
